import React, {useState, useEffect} from 'react'
import SearchList from '../components/SearchList';
import firebase from '../firebase/config'
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';

export default function CuentaMonedaNacional({bankList}) {

    const [user, setUser] = useState({})
    const [bancosSearched, setBancosSearched] = useState([])

    const [btnMessage, setBtnMessage] = useState("Guardar datos bancarios")

    const [banco, setBanco] = useState("")
    const [numeroMovil, setNumeroMovil] = useState("")
    
    const [dataBank, setDataBank] = useState({
        nombreTitular: "",
        rif: "",
        nroCuenta: "",
        tipoCuenta: "",
        email: "",
        codigoInterbancario: "",
    })

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
            setUser(val)
        })
    }, [])

    return (
        <div className="data-bank-account-container w-100">
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Banco</span>
                <SearchList colLg={true} style={{ width: "100%" }} customOnClick={(e)=>{console.log(e)}} validate={true} valueListDefined={bankList} statusValueLetter={setBanco} valueLetter={banco} statusValueList={setBancosSearched} valueList={bancosSearched.sort()}/>
            </div>
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Nombre del titular</span>
                <input type="text" className="form-control" value={dataBank.nombreTitular} onChange={(e)=>{setDataBank({...dataBank, nombreTitular: e.target.value})}}/>
            </div>
            <div className="form-row px-3">
                <div className="form-group col-md-6 col-lg-6 col-sm-12">
                    <span className="input-label">RIF</span>
                    <input type="text" className="form-control" value={dataBank.rif} onChange={(e)=>{setDataBank({...dataBank, rif: e.target.value})}}/>
                </div>
                <div className="form-group col-md-6 col-lg-6 col-sm-12">
                    <span className="input-label">Nro. de cuenta</span>
                    <input type="text" className="form-control" value={dataBank.nroCuenta} onChange={(e)=>{setDataBank({...dataBank, nroCuenta: e.target.value})}}/>
                </div>
            </div>
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Código interbancario</span>
                <input type="text" className="form-control" value={dataBank.codigoInterbancario} onChange={(e)=>{setDataBank({...dataBank, codigoInterbancario: e.target.value})}}/>
            </div>
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Tipo de cuenta</span>
                <select className="form-control" value={dataBank.tipoCuenta} onChange={(e)=>{setDataBank({...dataBank, tipoCuenta: e.target.value})}}>
                    <option value="">Selecciona el tipo de cuenta</option>
                    <option value="Ahorro">Ahorro</option>
                    <option value="Corriente">Corriente</option>
                </select>
            </div>
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Correo electrónico</span>
                <input type="email" className="form-control" value={dataBank.email} onChange={(e)=>{setDataBank({...dataBank, email: e.target.value})}}/>
            </div>
            <div className="form-group col-md-12 col-lg-12 col-sm-12">
                <span className="input-label">Número movil</span>
                <PhoneInput
                // defaultCountry={countryInfo.codigoTexto}
                value={numeroMovil} onChange={setNumeroMovil}/> 
            </div>
            <div className="row no-gutters justify-content-end">
                <div onClick={()=>{updateDataBank()}} className="col-lg-5 btn btn-primary">{btnMessage}</div>
            </div>
        </div>
    )

    async function updateDataBank(){
        setBtnMessage("Cargando...")
        try{
            
            await firebase.db.collection("Aliados").doc(user.aliadoId).collection("Datos Bancarios").doc("CuentaMonedaNacional").set({
                dataId: "CuentaMonedaNacional",
                banco: banco,
                numeroMovil: numeroMovil,
                nombreTitular: dataBank.nombreTitular,
                codigoInterbancario: dataBank.codigoInterbancario,
                rif: dataBank.rif,
                nroCuenta: dataBank.nroCuenta,
                tipoCuenta: dataBank.tipoCuenta,
                email: dataBank.email,
                
                createdOn: moment().toDate()
            })

        }catch(e){
            console.log("Error: " + e)
        }
        
        setBtnMessage("Guardar datos bancarios")
    }

}
